module.exports = __webpack_public_path__ + "static/img/tari.dd06bb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/tari.jpg
// module id = 505
// module chunks = 11